module.exports = __webpack_public_path__ + "img/LBC_Express.b30a6874.png";